<template>
  <div class="common-text-box-small mb-4">
    <div v-show="showTitle" class="flex items-center justify-start mb-2">
      <span class="mr-2">{{ title }}</span>
      <span v-show="required" class="required"> * </span>
    </div>
    <vs-textarea
      class="w-full"
      v-model="inputValue"
      :placeholder="placeholder"
      :class="{ 'is-error': error }"
    ></vs-textarea>
  </div>
</template>

<script>

export default {
  name: "M.CommonTextBoxLarge",
  props: {
    title: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
    },
    name: {
      type: String,
      required: false
    },
    validate: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      inputValue: "",
      error: false,
    }
  },

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-text-box-small {
  .required {
    color: $aisea-red;
  }

  .is-error {
    border: solid 1px $aisea-red;
  }
}
</style>